import React from 'react';
import { Quote, CheckCircle } from 'lucide-react';
import supportContent from '../../content/support/index.json';

const FounderPilotCard = () => {
  const f = supportContent.founder;
  if (!f) return null;

  return (
    <section className="py-16 bg-[#FFF8F5]" data-testid="founder-pilot-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-3xl p-8 sm:p-10 shadow-lg border border-[#B5541B]/10">
          <h2 className="text-2xl sm:text-3xl font-bold text-[#1F1E1E] mb-6">{f.heading}</h2>
          <div className="flex flex-col sm:flex-row gap-6 items-start">
            <div className="shrink-0">
              {f.image ? (
                <img
                  src={f.image}
                  alt={f.attribution}
                  data-testid="founder-photo"
                  className="w-20 h-20 rounded-full object-cover border-2 border-[#B5541B]/20"
                />
              ) : (
                <div
                  data-testid="founder-avatar-fallback"
                  className="w-20 h-20 rounded-full bg-[#B5541B]/10 flex items-center justify-center text-[#B5541B] font-bold text-xl"
                >
                  SA
                </div>
              )}
            </div>
            <div className="flex-1">
              <Quote className="w-6 h-6 text-[#B5541B]/40 mb-2" />
              <p className="text-[#1F1E1E] leading-relaxed italic mb-3" data-testid="founder-quote">
                &ldquo;{f.quote}&rdquo;
              </p>
              <p className="text-sm font-semibold text-[#B5541B]">— {f.attribution}</p>
            </div>
          </div>
          <ul className="grid sm:grid-cols-3 gap-3 mt-8">
            {(f.model || []).map((item, i) => (
              <li key={i} className="flex items-start gap-2 text-sm text-[#3B3535]/85 bg-[#FFF8F5] rounded-xl p-3.5">
                <CheckCircle className="w-4 h-4 text-[#B5541B] mt-0.5 shrink-0" />
                {item}
              </li>
            ))}
          </ul>
          <p className="mt-6 text-xs text-[#3B3535]/60 leading-relaxed border-t border-gray-100 pt-4" data-testid="founder-boundary-note">
            {f.boundary}
          </p>
        </div>
      </div>
    </section>
  );
};

export default FounderPilotCard;
